import { DynamicPointSize } from '../DynamicPointSize';
import * as state from '@/state';
import { useAtomValue } from 'jotai';
import { PointSizeSlider } from '../PointSizeSlider';

export const PointSizeControls = () => {
  const enableDynamicPointSize = useAtomValue<boolean>(state.enableDynamicPointSize);

  return (
    <>
      {<DynamicPointSize />}

      {!enableDynamicPointSize && (
        <PointSizeSlider title="Point size" step={0.5} min={0} max={10} />
      )}
    </>
  );
};
